import React, { useState, useContext } from "react";
import { Modal, ModalBody } from "@windmill/react-ui";
import { SidebarContext } from "context/SidebarContext";
import { IoIosClose } from "react-icons/io";
import CommonCloseBtn from "components/CloseButton/CommonCloseButton";
const Tab = ({ label, onClick, isActive }) => {
  return (
    <div
      onClick={onClick}
      className={`shrink-0 border-b-2 px-1 pb-4 text-sm font-medium cursor-pointer ${
        isActive
          ? "border-green-500 text-green-600"
          : "border-transparent text-gray-500"
      } text-nowrap`}
    >
      {label}
    </div>
  );
};

const renderImage = (image, i) => {
  return (
    <img
      className="inline-flex border rounded-md border-gray-100 dark:border-gray-600 w-24 max-h-24 p-2 m-2"
      src={process.env.REACT_APP_API_IMAGE_URL + image}
      alt="Preview"
    />
  );
};

const ViewModal = ({ id, title, data }) => {
  const { isViewModalOpen, closeModal } = useContext(SidebarContext);
  var result = data.find((item) => item.id === id);

  const [activeTab, setActiveTab] = useState("1");

  const handleTabClick = (label) => {
    setActiveTab(label);
  };
  const style = `{
    .custom-modal button {
      position: absolute;
      top: 10px;
      right: 10px;
      background-color: transparent;
      border: none;
      cursor: pointer;
      font-size: 16px;
      color: #333;
      outline:none !important;
    }
    .custom-modal button:hover {
      color: #FF0000 !important; 
      outline:none;
    } 
      .custom-modal button:focus {
      color: #FF0000 !important; 
      outline:none; 
    }
    .custom-modal {
      overflow: auto;
    }
    
    `;

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);

  const openZoomModal = (image) => {
    setSelectedImage(image);
    setIsModalOpen(true);
  };

  const closeZoomModal = () => {
    setSelectedImage(null);
    setIsModalOpen(false);
  };
  return (
    <>
      <style>{style}</style>

      <Modal
        className="relative bg-white dark:bg-gray-700 dark:text-white w-1/2 rounded-lg"
        isOpen={isViewModalOpen}
        onClose={closeModal}
      >
        <ModalBody className="custom-modal pb-3">
          <CommonCloseBtn onClose={closeModal} />
          <nav className="-mb-px flex px-3 gap-6" aria-label="Tabs">
            <Tab
              className="focus:outline-none dark:text-gray-300"
              sx={{ color: "#057a55", outline: "none" }}
              label="Basic Details"
              onClick={() => handleTabClick("1")}
              isActive={activeTab === "1"}
            />
            {result && result["Vendor Type"] !== "Owner" && (
              <Tab
                className="focus:outline-none dark:text-gray-300"
                sx={{
                  color: "#057a55",
                  outline: "none",
                }}
                label="Company Details"
                onClick={() => handleTabClick("2")}
                isActive={activeTab === "2"}
              />
            )}

            <Tab
              className="focus:outline-none dark:text-gray-300"
              sx={{ color: "#057a55", outline: "none" }}
              label="ID Proof Details"
              onClick={() => handleTabClick("3")}
              isActive={activeTab === "3"}
            />
            <Tab
              className="focus:outline-none dark:text-gray-300"
              sx={{ color: "#057a55", outline: "none" }}
              label="PAN & GST Details"
              onClick={() => handleTabClick("4")}
              isActive={activeTab === "4"}
            />
            <Tab
              className="focus:outline-none dark:text-gray-300"
              sx={{ color: "#057a55", outline: "none" }}
              label="Bank Details"
              onClick={() => handleTabClick("5")}
              isActive={activeTab === "5"}
            />
          </nav>

          {/* Tab Content */}
          <div
            className="p-4 mt-3 overflow-y-scroll"
            style={{
              maxHeight: "400px",
              scrollbarWidth: "thin",
            }}
          >
            {activeTab === "1" && (
              <div className="-my-3 border rounded-lg border-gray-300 dark:border-gray-500 text-sm dark:text-white">
                <div className="grid grid-cols-1 gap-1 p-3 sm:grid-cols-3 sm:gap-4">
                  <dt className="font-medium text-gray-900 dark:text-gray-200">
                    Company type
                  </dt>
                  <dd className="text-gray-700 dark:text-gray-200 sm:col-span-2 pl-20 ">
                    {result ? result["company_type"] : ""}
                  </dd>
                </div>

                <div className="grid grid-cols-1 gap-1 p-3 sm:grid-cols-3 sm:gap-4">
                  <dt className="font-medium text-gray-900 dark:text-gray-200">
                    Reference No
                  </dt>
                  <dd className="text-gray-700 dark:text-gray-200 sm:col-span-2 pl-20 ">
                    {result ? result["reference_no"] : ""}
                  </dd>
                </div>
                <div className="grid grid-cols-1 gap-1 p-3 sm:grid-cols-3 sm:gap-4">
                  <dt className="font-medium text-gray-900 dark:text-gray-200">
                    Franchise Name
                  </dt>
                  <dd className="text-gray-700 dark:text-gray-200 sm:col-span-2 pl-20 ">
                    {result?.franchise_partner_name || "-"}
                  </dd>
                </div>

                <div className="grid grid-cols-1 gap-1 p-3 sm:grid-cols-3 sm:gap-4">
                  <dt className="font-medium text-gray-900 dark:text-gray-200">
                    City,State
                  </dt>
                  <dd className="text-gray-700 dark:text-gray-200 sm:col-span-2 pl-20">
                    {result?.city}
                  </dd>
                </div>
                <div className="grid grid-cols-1 gap-1 p-3 sm:grid-cols-3 sm:gap-4">
                  <dt className="font-medium text-gray-900 dark:text-gray-200">
                    Address
                  </dt>
                  <dd className="text-gray-700 dark:text-gray-200 sm:col-span-2 pl-20">
                    {result ? result["address"] : ""}
                  </dd>
                </div>

                <div className="grid grid-cols-1 gap-1 p-3 sm:grid-cols-3 sm:gap-4">
                  <dt className="font-medium text-gray-900 dark:text-gray-200">
                    Authorized Person
                  </dt>
                  <dd className="text-gray-700 dark:text-gray-200 sm:col-span-2 pl-20">
                    {result?.authorized_person}
                  </dd>
                </div>
                <div className="grid grid-cols-1 gap-1 p-3 sm:grid-cols-3 sm:gap-4">
                  <dt className="font-medium text-gray-900 dark:text-gray-200">
                    Email
                  </dt>
                  <dd className="text-gray-700 dark:text-gray-200 sm:col-span-2 pl-20">
                    {result?.email}
                  </dd>
                </div>
                <div className="grid grid-cols-1 gap-1 p-3 sm:grid-cols-3 sm:gap-4">
                  <dt className="font-medium text-gray-900 dark:text-gray-200">
                    Password
                  </dt>
                  <dd className="text-gray-700 dark:text-gray-200 sm:col-span-2 pl-20">
                    {result?.password}
                  </dd>
                </div>
                <div className="grid grid-cols-1 gap-1 p-3 sm:grid-cols-3 sm:gap-4">
                  <dt className="font-medium text-gray-900 dark:text-gray-200">
                    Contact No
                  </dt>
                  <dd className="text-gray-700 dark:text-gray-200 sm:col-span-2 pl-20">
                    {result?.contact_no}
                  </dd>
                </div>

                <div className="grid grid-cols-1 gap-1 p-3 sm:grid-cols-3 sm:gap-4">
                  <dt className="font-medium text-gray-900 dark:text-gray-200">
                    Alternate Contact No
                  </dt>
                  <dd className="text-gray-700 dark:text-gray-200 sm:col-span-2 pl-20">
                    {result?.al_contact_no}
                  </dd>
                </div>
                <div className="grid grid-cols-1 gap-1 p-3 sm:grid-cols-3 sm:gap-4">
                  <dt className="font-medium text-gray-900 dark:text-gray-200">
                    Services Eligible
                  </dt>
                  <dd className="text-gray-700 dark:text-gray-200 sm:col-span-2 pl-20">
                    {result?.service_type &&
                    Array.isArray(result.service_type) &&
                    result.service_type.length > 0
                      ? result.service_type.join(", ")
                      : "No services selected"}
                  </dd>
                </div>
                <div className="grid grid-cols-1 gap-1 p-3 sm:grid-cols-3 sm:gap-4">
                  <dt className="font-medium text-gray-900 dark:text-gray-200">
                    Refered By
                  </dt>
                  <dd className="text-gray-700 dark:text-gray-200 sm:col-span-2 pl-20">
                    {result?.refered_by}
                  </dd>
                </div>
                {/* <div className="grid grid-cols-1 gap-1 p-3 sm:grid-cols-3 sm:gap-4">
                  <dt className="font-medium text-gray-900 dark:text-gray-200">
                    Block Remarks
                  </dt>
                  <dd className="text-gray-700 dark:text-gray-200 sm:col-span-2 pl-20">
                    {result?.block_remark}
                  </dd>
                </div>
                <div className="grid grid-cols-1 gap-1 p-3 sm:grid-cols-3 sm:gap-4">
                  <dt className="font-medium text-gray-900 dark:text-gray-200">
                    Unblock Remarks
                  </dt>
                  <dd className="text-gray-700 dark:text-gray-200 sm:col-span-2 pl-20">
                    {result?.unblock_remark}
                  </dd>
                </div> */}
              </div>
            )}
            {activeTab === "2" && (
              <div className="-my-3 border rounded-lg border-gray-300 dark:border-gray-500 text-sm dark:text-white">
                <div className="grid grid-cols-1 gap-1 p-3 sm:grid-cols-3 sm:gap-4">
                  <dt className="font-medium text-gray-900 dark:text-gray-200">
                    Company Name
                  </dt>
                  <dd className="text-gray-700 dark:text-gray-200 sm:col-span-2 pl-20 ">
                    {result ? result["company_name"] : ""}
                  </dd>
                </div>

                <div className="grid grid-cols-1 gap-1 p-3 sm:grid-cols-3 sm:gap-4">
                  <dt className="font-medium text-gray-900 dark:text-gray-200">
                    Pincode
                  </dt>
                  <dd className="text-gray-700 dark:text-gray-200 sm:col-span-2 pl-20">
                    {result?.pincode}
                  </dd>
                </div>

                <div className="grid grid-cols-1 gap-1 p-3 sm:grid-cols-3 sm:gap-4">
                  <dt className="font-medium text-gray-900 dark:text-gray-200">
                    Destination
                  </dt>
                  <dd className="text-gray-700 dark:text-gray-200 sm:col-span-2 pl-20">
                    {result?.destination}
                  </dd>
                </div>
              </div>
            )}
            {activeTab === "3" && (
              <div className="-my-3 border rounded-lg border-gray-300 dark:border-gray-500 text-sm dark:text-white">
                <div className="grid grid-cols-1 gap-1 p-3 sm:grid-cols-3 sm:gap-4">
                  <dt className="font-medium text-gray-900 dark:text-gray-200">
                    Proof Type
                  </dt>
                  <dd className="text-gray-700 dark:text-gray-200 sm:col-span-2 pl-20 ">
                    {result?.proof_type}
                  </dd>
                </div>
                <div className="grid grid-cols-1 gap-1 p-3 sm:grid-cols-3 sm:gap-4">
                  <dt className="font-medium text-gray-900 dark:text-gray-200">
                    Name in Proof
                  </dt>
                  <dd className="text-gray-700 dark:text-gray-200 sm:col-span-2 pl-20">
                    {result?.name_in_proof}
                  </dd>
                </div>
                <div className="grid grid-cols-1 gap-1 p-3 sm:grid-cols-3 sm:gap-4">
                  <dt className="font-medium text-gray-900 dark:text-gray-200">
                    Proof ID Number
                  </dt>
                  <dd className="text-gray-700 dark:text-gray-200 sm:col-span-2 pl-20">
                    {result?.id_proof}
                  </dd>
                </div>
                <div className="grid grid-cols-1 gap-1 p-3 sm:grid-cols-3 sm:gap-4">
                  <dt className="font-medium text-gray-900 dark:text-gray-200">
                    ID Proof
                  </dt>
                  <dd
                    className="text-gray-700 dark:text-gray-200 sm:col-span-2 pl-20"
                    onClick={() => openZoomModal(result.proof_image)}
                  >
                    {result && Array.isArray(result.proof_image) && (
                      <>
                        {result.proof_image.map((image, i) =>
                          renderImage(image, i),
                        )}
                      </>
                    )}

                    {result &&
                      result.proof_image &&
                      renderImage(result.proof_image)}
                  </dd>
                </div>
              </div>
            )}
            {activeTab === "4" && (
              <div className="-my-3 border rounded-lg border-gray-300 dark:border-gray-500 text-sm dark:text-white">
                <div className="grid grid-cols-1 gap-1 p-3 sm:grid-cols-3 sm:gap-4">
                  <dt className="font-medium text-gray-900 dark:text-gray-200">
                    Pan No
                  </dt>
                  <dd className="text-gray-700 dark:text-gray-200 sm:col-span-2 pl-20 ">
                    {result?.pan_no}
                  </dd>
                </div>
                <div className="grid grid-cols-1 gap-1 p-3 sm:grid-cols-3 sm:gap-4">
                  <dt className="font-medium text-gray-900 dark:text-gray-200">
                    Pan Image
                  </dt>
                  <dd
                    className="text-gray-700 dark:text-gray-200 sm:col-span-2 pl-20"
                    onClick={() => openZoomModal(result.pan_image)}
                  >
                    {result && Array.isArray(result.pan_image) && (
                      <>
                        {result.pan_image.map((image, i) =>
                          renderImage(image, i),
                        )}
                      </>
                    )}

                    {result &&
                      result.pan_image &&
                      renderImage(result.pan_image)}
                  </dd>
                </div>

                <div className="grid grid-cols-1 gap-1 p-3 sm:grid-cols-3 sm:gap-4">
                  <dt className="font-medium text-gray-900 dark:text-gray-200">
                    Gst No(Optional)
                  </dt>
                  <dd className="text-gray-700 dark:text-gray-200 sm:col-span-2 pl-20">
                    {result?.gst_no}
                  </dd>
                </div>

                <div className="grid grid-cols-1 gap-1 p-3 sm:grid-cols-3 sm:gap-4">
                  <dt className="font-medium text-gray-900 dark:text-gray-200">
                    Gst Image(Optional)
                  </dt>
                  <dd
                    className="text-gray-700 dark:text-gray-200 sm:col-span-2 pl-20"
                    onClick={() => openZoomModal(result.gst_image)}
                  >
                    {result && Array.isArray(result.gst_image) && (
                      <>
                        {result.gst_image.map((image, i) =>
                          renderImage(image, i),
                        )}
                      </>
                    )}

                    {result &&
                      result.gst_image &&
                      renderImage(result.gst_image)}
                  </dd>
                </div>
              </div>
            )}

            {activeTab === "5" && (
              <div className="-my-3 border rounded-lg border-gray-300 dark:border-gray-500 text-sm dark:text-white">
                <div className="grid grid-cols-1 gap-1 p-3 sm:grid-cols-3 sm:gap-4">
                  <dt className="font-medium text-gray-900 dark:text-gray-200">
                    Account No
                  </dt>
                  <dd className="text-gray-700 dark:text-gray-200 sm:col-span-2 pl-20 ">
                    {result?.account_no}
                  </dd>
                </div>
                <div className="grid grid-cols-1 gap-1 p-3 sm:grid-cols-3 sm:gap-4">
                  <dt className="font-medium text-gray-900 dark:text-gray-200">
                    Beneficiary Name
                  </dt>
                  <dd className="text-gray-700 dark:text-gray-200 sm:col-span-2 pl-20 ">
                    {result?.beneficiary_name}
                  </dd>
                </div>
                <div className="grid grid-cols-1 gap-1 p-3 sm:grid-cols-3 sm:gap-4">
                  <dt className="font-medium text-gray-900 dark:text-gray-200">
                    IFSC Code
                  </dt>
                  <dd className="text-gray-700 dark:text-gray-200 sm:col-span-2 pl-20 ">
                    {result?.ifsc_code}
                  </dd>
                </div>
                <div className="grid grid-cols-1 gap-1 p-3 sm:grid-cols-3 sm:gap-4">
                  <dt className="font-medium text-gray-900 dark:text-gray-200">
                    Canceled Check Image
                  </dt>
                  <dd
                    className="text-gray-700 dark:text-gray-200 sm:col-span-2 pl-20"
                    onClick={() => openZoomModal(result.check_leaflet_image)}
                  >
                    {result && Array.isArray(result.check_leaflet_image) && (
                      <>
                        {result.check_leaflet_image.map((image, i) =>
                          renderImage(image, i),
                        )}
                      </>
                    )}

                    {result &&
                      result.check_leaflet_image &&
                      renderImage(result.check_leaflet_image)}
                  </dd>
                </div>
              </div>
            )}
          </div>
          {isModalOpen && (
            <div
              className="fixed inset-0 flex items-center justify-center z-50 bg-black bg-opacity-50"
              onClick={(e) => {
                // Close modal if clicking on the backdrop
                if (e.target === e.currentTarget) {
                  closeZoomModal();
                }
              }}
            >
              <div className="bg-white dark:bg-gray-600 p-4 rounded-lg max-w-md w-full relative">
                <button
                  onClick={closeZoomModal}
                  className="viewModelBoxCloseBtn bg-white dark:bg-gray-600 dark:text-white absolute top-2 right-2 text-2xl"
                >
                  <IoIosClose />
                </button>

                <img
                  src={process.env.REACT_APP_API_IMAGE_URL + selectedImage}
                  alt="Selected Company Logo"
                  className="w-full h-auto rounded-lg"
                />
              </div>
            </div>
          )}
        </ModalBody>
      </Modal>
    </>
  );
};

export default React.memo(ViewModal);
